module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_list,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.selectGA
    },
    model: {
      value: (_vm.trip.region),
      callback: function($$v) {
        _vm.$set(_vm.trip, "region", $$v)
      },
      expression: "trip.region"
    }
  })], 1), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                    Geographical Area is a required field\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.vehicle_no,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.getDeviceName
    },
    model: {
      value: (_vm.trip.vehicleId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "vehicleId", $$v)
      },
      expression: "trip.vehicleId"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "message",
      "placeholder": "Device",
      "id": "chat-input"
    },
    domProps: {
      "value": (_vm.trip.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "deviceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "journeyManager"
    }
  }, [_vm._v("\n                    Drivers\n                  ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "drivers",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.driverStatus
    },
    model: {
      value: (_vm.trip.driverId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "driverId", $$v)
      },
      expression: "trip.driverId"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.HCVOperationStatus
    },
    model: {
      value: (_vm.trip.regionManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "regionManager", $$v)
      },
      expression: "trip.regionManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.journeyManagerStatus
    },
    model: {
      value: (_vm.trip.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "journeyManager", $$v)
      },
      expression: "trip.journeyManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "disabled": "",
      "required": "",
      "lang": "en",
      "name": "scheduleDate",
      "not-before": _vm.disabledBefore,
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduledTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduledTime",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduledTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.remark),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.remark),
      expression: "trip.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "Remarks"
    },
    domProps: {
      "value": (_vm.trip.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "remark", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))]), _vm._v(" "), _c('vue-select', {
      attrs: {
        "label": "siteName",
        "options": _vm.getFilteredLocationList(
          index
        ),
        "searchable": true,
        "language": "en-US"
      },
      on: {
        "change": function($event) {
          return _vm.handleChange($event, index)
        }
      },
      model: {
        value: (input.locationId),
        callback: function($$v) {
          _vm.$set(input, "locationId", $$v)
        },
        expression: "input.locationId"
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1), _vm._v(" "), (index === _vm.locations.length - 2) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField('locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]) : _vm._e(), _vm._v(" "), (index > 1 && index < _vm.locations.length - 1) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, 'locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })]) : _vm._e()], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$valid && _vm.formValid)
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v("\n              Add Group Trip\n            ")])], 1)], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Start Location",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "End Location",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Time"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createRoute()
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49af88cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip-group/Trip-Group-Create.vue
// module id = 1977
// module chunks = 1